var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"v-tag btn",class:[("btn-" + _vm.type), ( _obj = {}, _obj[("btn-" + _vm.size)] = _vm.size, _obj )]},[_c('div',{staticClass:"date-container"},[_c('span',{staticClass:"date-entry"},[_vm._v(_vm._s(_vm.nice_date))]),_c('i',{staticClass:"fa-lg",class:_vm.icon,on:{"click":function($event){return _vm.$emit('delete', _vm.notice.notice_date)}}})])])}
var staticRenderFns = []

export { render, staticRenderFns }